/* eslint-disable import/prefer-default-export */

export function getFileShareId(id) {
  return `${id}_fileshare_${parseInt(
    1000000000 + Math.random() * 1000000000,
    10
  )}`;
}
